import { PaymentApi } from "@app/services/apiServices/PaymentApi";
import { HeaderService } from "@app/components/header/header.service";
import { PaymentRequest } from "@app/models/PaymentRequest";
import { Homeowner } from "@app/models/Homeowner";
import { GuestPaymentStore } from "@app/services/stores/GuestPaymentStore";
import { SpinnerService } from "@app/services/spinner.service";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { PrintService } from "@app/services/Print.service";
import { PaymentEntityType } from "@app/models/PaymentEntityType";
import { take } from "rxjs/operators";
import { Component, Inject, OnInit } from "@angular/core";
import { WindowToken } from "@app/util/window.token";
import { MatDialog } from "@angular/material/dialog";
import { AppDataService } from "@app/services/appData.service";
import { DialogErrorDialog } from "@app/components/sharedDialogs/dialogError.dialog";
import { DialogPreCancelComponent } from "@app/components/sharedDialogs/dialogPreCancel.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ContentApi } from "@app/services/apiServices/ContentApi";
import { FeatureFlagService } from "@app/services/feature-flag.service";

@Component({
    selector: 'app-guest-payment-success',
    template: require('./guestPaymentSuccess.html')
})
export class GuestPaymentSuccessComponent implements OnInit {
    paymentRequest: PaymentRequest;
    homeowner: Homeowner;
    paymentConfirmationNumber: any;
    paymentId: number;
    paymentEntityType: PaymentEntityType;
    $stateParams: any;
    thankYouMsg;
    isAsyncFeatureEnabled: boolean = false;

    constructor(
        @Inject(WindowToken) private window: Window,
        @Inject(PrintService) private printService: PrintService,
        @Inject(HeaderService) private headerService: HeaderService,
        @Inject(GuestPaymentStore) private guestPaymentStore: GuestPaymentStore,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(PaymentApi) private paymentApi: PaymentApi,
        @Inject(SpinnerService) private spinnerService: SpinnerService,
        @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
        @Inject(AppDataService) private appDataService: AppDataService,
        @Inject(Router) private router: Router,
        @Inject(ActivatedRoute) private route: ActivatedRoute,
        @Inject(ContentApi) private ContentApi: ContentApi,
        @Inject(FeatureFlagService) private featureFlagService: FeatureFlagService)
    {
        if (this.router.getCurrentNavigation()) {
            this.$stateParams = this.router.getCurrentNavigation().extras.state;
        }
    }

    ngOnInit() {
        this.fetchThankYouMessage();
        this.headerService.setDisplayRightContent(false);
        // Set the feature flag value
        this.isAsyncFeatureEnabled = this.featureFlagService.isAsyncFeatureEnabled();

        this.paymentEntityType = this.route.snapshot.data.paymentEntityType;
        this.paymentRequest = this.guestPaymentStore.getPaymentRequest();
        this.homeowner = this.guestPaymentStore.getHomeowner();

        if (this.isAsyncFeatureEnabled) {
            // For async flow, we don't expect confirmation number and payment ID in state params
            if (!this.homeowner || !this.paymentRequest) {
                const webUrl = this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL;
                const guestPaymentUrl = `${webUrl}/guest/#/guestpayment`;
                this.window.location.replace(guestPaymentUrl);
            } else {
                this.guestPaymentStore.clearAllGuest();
            }
        } else {
            if (
                this.$stateParams &&
                this.$stateParams.paymentConfirmationNumber &&
                this.$stateParams.paymentId &&
                // also check to make sure these are present
                this.homeowner &&
                this.paymentRequest
            ) {
                this.paymentConfirmationNumber =
                    this.$stateParams.paymentConfirmationNumber;
                this.paymentId = Number(this.$stateParams.paymentId);
                this.guestPaymentStore.clearAllGuest();
            } else {
                const webUrl =
                    this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL;
                const guestPaymentUrl = `${webUrl}/guest/#/guestpayment`;
                this.window.location.replace(guestPaymentUrl);
            }
        }
    }

    fetchThankYouMessage() {
        this.ContentApi.fetchGlobalContentByLocationType('ppthank')
            .pipe(take(1)).subscribe(resp => {
                this.thankYouMsg = resp && resp ? decodeURIComponent(resp.msg) : ''
            });
    }

    goToWelcomePage() {
        this.guestPaymentStore.clearAllGuest();
        this.window.location.replace("/");
    }

    clickPrint() {
        this.printService.print("Successful Payment", "clicked Print button")
    }

    isPaymentDateToday() {
        let today = new Date();
        let paymentDate = new Date(this.paymentRequest.paymentDate.formattedFullDate);

        return today.toDateString() === paymentDate.toDateString();
    }

    cancelPreCancel() {
        let dialogRef = this.dialog.open(DialogPreCancelComponent, {
            data: { paymentAmount: this.paymentRequest.payment.totalPaymentAmount }
        });
        dialogRef.afterClosed().subscribe((value) => {
            if (value === 'cancel') {
                this.spinnerService.showSpinner();
                this.paymentApi.deletePayment(true, this.paymentId)
                    .pipe(take(1)).subscribe((resp) => {
                        this.spinnerService.closeSpinner();
                        if (resp.status === 200) {
                            const route =
                            this.paymentEntityType === PaymentEntityType.AMENITY ? '/amenities/guestPaymentCancel' : '/guestPaymentCancel'
                            this.router.navigateByUrl(route, { state: {
                                'homeowner': this.homeowner,
                                'paymentRequest': this.paymentRequest,
                                'paymentConfirmationNumber': this.paymentConfirmationNumber,
                                'paymentId': this.paymentId
                            } });
                        } else {
                            let dialogRefErr = this.dialog.open(DialogErrorDialog);
                            dialogRefErr.afterClosed().subscribe((data) => {
                                if (data === 'Retry') {
                                    this.cancelPreCancel();
                                }
                            });
                        }
                    }, (err) => {
                        this.networkErrorService.handleNetworkError(err, true)
                            .pipe(take(1)).subscribe((resp) => {
                                if (resp === true) {
                                    this.cancelPreCancel();
                                }
                            });
                    });
            }
        });
    }
}

